import React from "react";
import { Modal, Space, Image } from "antd";

const QrCodePopUp = (props) => {
  const {
    title,
    qrCodeVisible,
    handleScanQrCode,
    handleCancelQrCode,
    qrCodeUrl,
    closable,
    footer
  } = props;
  return (
    <Modal
    closable={closable}
      title={title}
      centered
      visible={qrCodeVisible}
      onOk={handleScanQrCode}
      onCancel={handleCancelQrCode}
      width={400}
      footer={footer}
      okText="确认"
      cancelText="取消"
    >
      <>
        <Space
          size="large"
          direction="vertical"
        >
          <Image src={qrCodeUrl} width={352}/>
        </Space>
      </>
    </Modal>
  );
};

export default QrCodePopUp;
